module.exports = __webpack_public_path__ + "static/sales-main-99a7b8a7a5f79561a6528431b176c60c.svg";